import { render, staticRenderFns } from "./ViewResidentModal.vue?vue&type=template&id=9efa3d0e&"
import script from "./ViewResidentModal.vue?vue&type=script&lang=js&"
export * from "./ViewResidentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports